export default __webpack_public_path__ + "static/media/header-back.66ede195.jpg";